import React, { useState } from "react";
//  import { CNavbar, CContainer, CNavbarBrand, CNavItem, CNavLink, CNavbarToggler, CNavbarNav, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react';
import { NavLink } from "react-router-dom";

const Header = () => {
  const [isDropdownOpenInvestor, setIsDropdownOpenInvestor] = useState(false);

  const handleDropdownHoverInvestor = () => {
    setIsDropdownOpenInvestor(!isDropdownOpenInvestor);
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-light">
        <div className="container-fluid">
          <NavLink className="navbar-brand" to="/">
            <img
              src="assets/img/logo-dark.png"
              alt="Blackopal"
              width={140}
              height={50}
              className="logo-20px"
            />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav mb-2 mb-lg-0">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  activeClassName="active"
                  to="/Aboutus"
                >
                  About Us
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  activeClassName="active"
                  to="/OurServices"
                >
                  Our Services
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  activeClassName="active"
                  to="/Career"
                >
                  Career
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  activeClassName="active"
                  to="/Media"
                >
                  Media
                </NavLink>
              </li>
              <li
                className={`dropdown ${isDropdownOpenInvestor ? "open" : ""}`}
                onMouseEnter={handleDropdownHoverInvestor}
                onMouseLeave={handleDropdownHoverInvestor}
              >
                <NavLink
                  className="nav-link dropdown-toggle "
                  to="/"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  Investors
                </NavLink>
                <ul
                  className={`dropdown-menu ${
                    isDropdownOpenInvestor ? "show" : ""
                  }`}
                  aria-labelledby="navbarDropdown"
                >
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/FinancialAndReports"
                    >
                      Financials & Reports
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/share-governance-investor-services"
                    >
                      Share, Governance & Investor Services
                    </NavLink>
                  </li>
                <li>
                    <NavLink
                      className="dropdown-item"
                      to="/shareholder-pattern"
                    >
                      Shareholder Pattern
                    </NavLink>
                  </li>
                  <li>
                    <NavLink
                      className="dropdown-item"
                      to="/industry-search-report"
                    >
                      Industry Search Report
                    </NavLink>
                  </li> 

                  {/* <li>
                  <NavLink className="dropdown-item" to="/drhp">
                    DRHP
                  </NavLink>
                </li> */}
                  {/* <li className="relative group">
                    <span className="dropdown-item text-gray-400 cursor-not-allowed pointer-events-none">
                      DRHP
                    </span>

                   
                    <span className="absolute left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded-md px-2 py-1 whitespace-nowrap z-10">
                      Coming soon
                    </span>
                  </li> */}
                  {/* <li>
                  <NavLink className="dropdown-item" to="/AdvisoryServices">
                    Addendum to DRHP
                  </NavLink>
                </li> */}

                  {/* <li>
                    <NavLink className="dropdown-item" to="/addendum-to-drhp">
                      Addendum to DRHP
                    </NavLink>
                  </li> */}
                  {/* <li>
                  <NavLink className="dropdown-item" to="/AdvisoryServices">
                    Prospectus
                  </NavLink>
                </li> */}

                  {/* <li className="relative group">
                    <span className="dropdown-item text-gray-400 cursor-not-allowed pointer-events-none">
                      Prospectus
                    </span>

                    <span className="absolute left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded-md px-2 py-1 whitespace-nowrap z-10">
                      Coming soon
                    </span>
                  </li> */}

                  {/* <li>
                  <NavLink className="dropdown-item" to="/AdvisoryServices">
                    RHP
                  </NavLink>
                </li> */}
                  {/* <li className="relative group">
                    <span className="dropdown-item text-gray-400 cursor-not-allowed pointer-events-none">
                      RHP
                    </span>

                    <span className="absolute left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded-md px-2 py-1 whitespace-nowrap z-10">
                      Coming soon
                    </span>
                  </li> 

                
                  {/* <li className="relative group">
                    <span className="dropdown-item text-gray-400 cursor-not-allowed pointer-events-none">
                      Group Company
                    </span>

                   
                    <span className="absolute left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded-md px-2 py-1 whitespace-nowrap z-10">
                      Coming soon
                    </span>
                  </li> */}
                    <li>
                    <NavLink className="dropdown-item" to="/offer-documents">
                      Offer Documents
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/regulation-46-lodr">
                      Regulation 46 of LODR
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/regulation-30">
                      Regulation 30
                    </NavLink>
                  </li>
                  <li>
                    <NavLink className="dropdown-item" to="/corporate-announcements">
                      Corporate Announcements
                    </NavLink>
                  </li>
                  <li>
                  <NavLink className="dropdown-item" to="/Group-Entities">
                    Group Company
                  </NavLink>
                </li>
                  <li>
                    <NavLink className="dropdown-item " to="/MaterialContracts" >
                      Material Contracts
                    </NavLink>
                  </li>
                  <li>
                  <NavLink className="dropdown-item" to="/MaterialDocuments">
                    Material Documents
                  </NavLink>
                </li>
                  {/* <li className="relative group">
                    <span className="dropdown-item text-gray-400 cursor-not-allowed pointer-events-none">
                      Material Documents
                    </span>

                   
                    <span className="absolute left-1/2 -translate-x-1/2 mt-1 hidden group-hover:block bg-gray-800 text-white text-xs rounded-md px-2 py-1 whitespace-nowrap z-10">
                      Coming soon
                    </span>
                  </li> */}
                  {/* <li>
                  <NavLink className="dropdown-item" to="/AdvisoryServices">
                    Advertisement
                  </NavLink>
                </li> */}
                  <li>
                    <NavLink className="dropdown-item" to="/advertisement">
                      Advertisement
                    </NavLink>
                  </li>
                
                </ul>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  activeClassName="active"
                  to="/Contactus"
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Header;
